import { render, staticRenderFns } from "./Lang6.vue?vue&type=template&id=c8782676&scoped=true&"
import script from "./Lang6.vue?vue&type=script&lang=js&"
export * from "./Lang6.vue?vue&type=script&lang=js&"
import style0 from "./Lang6.vue?vue&type=style&index=0&id=c8782676&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8782676",
  null
  
)

export default component.exports